import { BlockBlobClient } from "@azure/storage-blob";
import { DateTime } from "luxon";
import EnvironmentVariables from "../../EnvironmentVariables";
import PrototypeInstance from "./prototype-instance";
import { constants } from "../constant/constants";
import {
  azureBlobResponse,
  uploadedAttachment,
} from "../model/azure-blob-response";
import { Enums } from "./enums";
import { HttpHelper } from "./http-helper-service";

export class AzureStorageService {
  static AzureStorageBaseUrl = `https://${EnvironmentVariables.azureStorageFileAccountName()}.blob.core.windows.net`;
  static sasToken = "";

  static async Upload(
    blobType: string,
    SelectedFile: File,
    SasToken: string = "",
    thumbnailType: Enums.ThumbnailType = Enums.ThumbnailType.None,
    innerFolder: string = "",
  ) {
    if (SasToken == "") {
      SasToken = await this.generateSasToken();
    }
    let fileName = SelectedFile.name.substring(
      0,
      SelectedFile.name.lastIndexOf("."),
    );
    fileName =
      fileName.replace(/[^a-zA-Z0-9_.]+/gi, "") +
      SelectedFile.name.substring(SelectedFile.name.lastIndexOf("."));

    let serviceProviderId: number =
      PrototypeInstance.globalProperties.$store.getters[
        "ContactModule/getServiceProviderId"
      ];
    let containerPath = `s-${serviceProviderId}`;
    let folderName: string = `${new Date().getTime()}`;
    let filePath = `${blobType}${innerFolder}/${folderName}/${fileName}`;
    let relativePath = `${containerPath}/${filePath}`;
    let uploadUrl: string = `${this.AzureStorageBaseUrl}/${relativePath}`;

    let blockBlobClient = new BlockBlobClient(`${uploadUrl}${SasToken}`);

    try {
      let blobResponse = await blockBlobClient.uploadBrowserData(SelectedFile);

      let attachment: uploadedAttachment = {
        fileName: SelectedFile.name,
        URL: uploadUrl,
        URLWithSasToken: uploadUrl + SasToken,
        relativeUrl: relativePath,
      };

      let responseModel: azureBlobResponse = {
        response: blobResponse,
        attachment: attachment,
      };

      return responseModel;
    } catch (e) {
      return null;
    }
  }

  static async DeleteFile(file: any, SasToken: string = "") {
    if (SasToken == "") {
      SasToken = await this.generateSasToken();
    }
    if (file.blobPath.includes("?sv")) {
      file.blobPath = file.blobPath.slice(0, file.blobPath.indexOf("?sv"));
    }

    const blockBlobClient = new BlockBlobClient(`${file.blobPath}${SasToken}`);

    let response = await blockBlobClient.delete();
    return response;
  }

  static async Delete(url: string, getSasToken: boolean) {
    if (getSasToken) {
      if (url.includes("?sv")) {
        url = url.slice(0, url.indexOf("?sv"));
      }

      await this.generateSasToken();
      if (this.sasToken) {
        const blockBlobClient = new BlockBlobClient(url + this.sasToken);
        return await blockBlobClient.delete();
      }
    } else {
      const blockBlobClient = new BlockBlobClient(url);
      return await blockBlobClient.delete();
    }
  }

  static getSASToken() {
    return HttpHelper.postData(constants.apiUrl.azureBlob.getSasToken, null);
  }

  static generateSasToken(): Promise<string> {
    return new Promise<string>((resolve) => {
      const fetchAndResolve = () => {
        this.getSASToken()
          .then((res: any) => {
            this.sasToken = res && res.sasToken ? res.sasToken : "";
            resolve(this.sasToken);
          })
          .catch(() => {
            this.sasToken = "";
            resolve("");
          });
      };
      if (this.sasToken == null || this.sasToken == "") {
        fetchAndResolve();
      } else if (this.checkIfSasTokenExpired(this.sasToken)) {
        fetchAndResolve();
      } else {
        resolve(this.sasToken);
      }
    });
  }

  static checkIfSasTokenExpired(sasToken: string) {
    let decodedSasToken: string = decodeURIComponent(sasToken);

    // Extract the expiry time parameter (se=)
    const expiryMatch = decodedSasToken.match(/[?&]se=([^&]*)/);
    if (!expiryMatch || !expiryMatch[1]) {
      return true; // Treat tokens without expiry as expired
    }

    const expiryTime = expiryMatch[1];
    const expiryDateTime = DateTime.fromISO(expiryTime, { zone: "utc" });

    // Check if the parsed date is valid
    if (!expiryDateTime.isValid) {
      return true; // Treat invalid dates as expired
    }

    const currentDateTime = DateTime.utc();
    return currentDateTime >= expiryDateTime;
  }
}
